import { ReactNode } from 'react';
import { SimilarPost } from '@anytag/graphql';
import { PostDetailInfluencerInfo, PostDetailStatistics, PostDetailsType } from '@anytag/shared-types';
import {
  Body,
  Date,
  Caption,
  Comments,
  SocialLink,
  Statistics,
  MediaPreview,
  SimilarPosts,
  InfluencerInfo,
  MediaPreviewProps
} from '../components';

export interface DetailsTemplateProps {
  loading?: boolean;
  className?: string;
  children?: ReactNode;
  postStatus?: ReactNode;
  objectFit?: 'contain' | 'cover';
  mediaPreviewProps?: MediaPreviewProps;
  data?: Partial<Pick<PostDetailsType, 'postUrl' | 'socialMedia' | 'postDate' | 'caption'>> & {
    isReel?: boolean;
    info: PostDetailInfluencerInfo;
    statistics?: PostDetailStatistics;
    video?: MediaPreviewProps['video'];
    images?: MediaPreviewProps['images'];
    similarPosts?: readonly SimilarPost[];
    comments?: PostDetailsType['commentsContent'];
  };
}

export const DetailsTemplate = ({
  data,
  loading,
  children,
  objectFit,
  className,
  postStatus,
  mediaPreviewProps
}: DetailsTemplateProps) => (
  <Body className={className} loading={loading}>
    {data ? (
      <>
        <div className="flex min-h-[inherit] flex-col gap-y-4">
          <div className="flex flex-1 gap-4">
            <MediaPreview video={data?.video} images={data?.images} isReel={data?.isReel} {...mediaPreviewProps} />

            <div className="flex flex-1 flex-col gap-y-4">
              <InfluencerInfo info={data.info} postStatus={postStatus} objectFit={objectFit} />
              {data.statistics ? <Statistics statistics={data.statistics} /> : null}
              <Caption caption={data?.caption} />
              <Comments socialMedia={data.socialMedia} comments={data?.comments} />
            </div>
          </div>

          {(data.postUrl && data.socialMedia) || data.postDate ? (
            <div className="flex flex-none items-center justify-between">
              <Date value={data.postDate} />
              <SocialLink className="ml-auto" postUrl={data.postUrl} socialMedia={data.socialMedia} />
            </div>
          ) : null}
        </div>

        <SimilarPosts posts={data?.similarPosts || []} socialMedia={data.socialMedia} />

        {children}
      </>
    ) : null}
  </Body>
);
